import IcEdit from '@assets/details-camera-icons/IcEdit';
import { Paging } from '@Core';
import { CameraTask, TaskStatus } from '@EcamModel/model/CameraTask';
import { Box, Stack, Tooltip } from '@mui/material';
import { FormValues, Mode } from '@pages/overview/components/PopUpTaskInUnCompleteCamera';
import color from '@theme/Colors';
import React, { Dispatch, SetStateAction } from 'react';
import { UseFormHandleSubmit } from 'react-hook-form';
import { MdClose, MdDone, MdOutlineDelete } from 'react-icons/md';

interface ActionButtonsProps {
    task: CameraTask;
    isEditing: boolean;
    disabled: boolean;
    handleSubmit: UseFormHandleSubmit<FormValues>;
    onSetListTask: Dispatch<SetStateAction<Paging<CameraTask>>>;
    handleConfirmUpsertTask: (data: FormValues) => void;
    setMode: (mode: Mode) => void;
    setTaskItem: (task: CameraTask) => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    task,
    isEditing,
    disabled,
    handleSubmit,
    onSetListTask,
    handleConfirmUpsertTask,
    setMode,
    setTaskItem,
}) => {
    return (
        <Stack width={'100%'} direction="row" alignItems="flex-end" spacing={0.5}>
            {isEditing ? (
                <>
                    <Tooltip placement="top" title="Save">
                        <Box
                            sx={{
                                width: 25,
                                height: 25,
                                background: disabled ? (theme) => theme.palette.primary.main : '#DDDDDD',
                                borderRadius: 2,
                                color: disabled ? '#fff' : '#85858A',
                                '&:hover': {
                                    background: disabled ? (theme) => theme.palette.primary.dark : '#DDDDDD',
                                    cursor: disabled ? 'pointer' : 'not-allowed',
                                    transition: '0.3s ease-in-out',
                                },
                            }}
                            display={'flex'}
                            alignItems="center"
                            justifyContent="center"
                            onClick={handleSubmit((data) => handleConfirmUpsertTask(data))}
                        >
                            <MdDone style={{ width: 16, height: 16 }} />
                        </Box>
                    </Tooltip>
                    <Tooltip placement="top" title="Close">
                        <Box
                            sx={{
                                width: 25,
                                height: 25,
                                background: (theme) => theme.palette.error.main,
                                borderRadius: 2,
                                color: '#fff',
                                '&:hover': {
                                    background: (theme) => theme.palette.error.dark,
                                    cursor: 'pointer',
                                    transition: '0.5s ease-in-out',
                                },
                            }}
                            display={'flex'}
                            alignItems="center"
                            justifyContent="center"
                            onClick={() => {
                                setTaskItem({} as CameraTask);
                                setMode(Mode.default);
                                onSetListTask?.((prev) => ({
                                    ...prev,
                                    rows: prev.rows.filter((task) => task.TaskName !== ''),
                                }));
                            }}
                        >
                            <MdClose style={{ width: 16, height: 16 }} />
                        </Box>
                    </Tooltip>
                </>
            ) : (
                <Stack direction={'row'} spacing={1} justifyContent={'end'} width={'100%'}>
                    {task.TaskStatus !== TaskStatus.Cancelled && (
                        <Tooltip placement="top" title="Edit">
                            <Box
                                sx={{
                                    width: 25,
                                    height: 25,
                                    background: color.secondary,
                                    borderRadius: 2,
                                    color: '#fff',
                                    '&:hover': {
                                        background: color.warning,
                                        cursor: 'pointer',
                                        transition: '0.5s ease-in-out',
                                    },
                                }}
                                display={'flex'}
                                alignItems="center"
                                justifyContent="center"
                                onClick={() => {
                                    setTaskItem(task);
                                    setMode(Mode.edit);
                                }}
                            >
                                <IcEdit style={{ width: 14, height: 14 }} />
                            </Box>
                        </Tooltip>
                    )}

                    <Tooltip placement="top" title="Delete task">
                        <Box
                            sx={{
                                width: 25,
                                height: 25,
                                background: (theme) => theme.palette.error.main,
                                borderRadius: 2,
                                color: '#fff',
                                '&:hover': {
                                    background: (theme) => theme.palette.error.dark,
                                    cursor: 'pointer',
                                    transition: '0.5s ease-in-out',
                                },
                            }}
                            display={'flex'}
                            alignItems="center"
                            justifyContent="center"
                            onClick={() => {
                                setTaskItem(task);
                                setMode(Mode.delete);
                            }}
                        >
                            <MdOutlineDelete style={{ width: 16, height: 16 }} />
                        </Box>
                    </Tooltip>
                </Stack>
            )}
        </Stack>
    );
};

export default ActionButtons;
